export const VisitModels = {
    Pending: "Pending",
    Active: "Active",
    Finished: "Finished",
    All: "All"
}


// WEBPACK FOOTER //
// ./src/Models/visitModels.js